module.exports = __webpack_public_path__ + "static/media/przyjazd.05c5b98c.svg";